// src/routes/dashboard.routes.js - UPDATED WITH ORDER ROUTES
import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import AuthGuard from '../guards/authGuard';
import DashboardLayout from '../layouts/dashboardLayout';
import userRoutes from './user.routes';
import productRoutes from './product.routes';
import orderRoutes from './order.routes'; // ✅ NEW IMPORT
import maintenanceRoutes from './maintenance.routes';

// Lazy load dashboard pages
const Dashboard = lazy(() => import('../pages/dashboard/dashboard'));
const AdminManagement = lazy(() => import('../pages/dashboard/adminManagement'));
const AdminProfile = lazy(() => import('../components/admin/adminProfile'));

const dashboardRoutes = {
  path: 'dashboard',
  element: (
    <AuthGuard>
      <DashboardLayout>
        <Suspense fallback={<div>Loading...</div>}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AuthGuard>
  ),
  children: [
    {
      path: '',
      element: <Dashboard />
    },
    {
      path: 'admins',
      children: [
        {
          path: '',
          element: <AdminManagement />
        },
        {
          path: 'create',
          element: <AdminManagement mode="create" />
        },
        {
          path: 'edit/:adminId',
          element: <AdminManagement mode="edit" />
        }
      ]
    },
    {
      path: 'profile',
      element: <AdminProfile />
    },
    // Add the user management routes
    userRoutes,
    // Add the product management routes
    productRoutes,
    // Add the order management routes ✅ NEW
    orderRoutes,
    maintenanceRoutes
  ]
};

export default dashboardRoutes;